import { createSlice } from "@reduxjs/toolkit";

export const InfoBox = createSlice({
  name: "Information-Box",
  initialState: {
    value: { status: false, message: "", title: "", resource: "" },
  },
  reducers: {
    updateInfoBoxMessage: (state, action) => {
      state.value.status = true;
      state.value.message = action?.payload?.message
        ? action?.payload?.message
        : "";
      state.value.title = action?.payload?.title ? action?.payload?.title : "";
      state.value.resource = action?.payload?.resource
        ? action?.payload?.resource
        : "";
    },
  },
});

export const { updateInfoBoxMessage } = InfoBox.actions;

export default InfoBox.reducer;
